<template>
    <div class="curves-integer-box-wrapper">
        <div class="curves-integer-box" style="margin-right: 5px;">
            <v-input
                    v-model="selectedValue"
                    v-validate="'max:100'"
                    :error-messages="errors.collect('selectedValue')"
                    data-vv-name="toValue"
                    data-vv-as="toValue"
            >
                <input v-model="selectedValue" type="text" placeholder="Top Curves"  @blur="onBlur"/>
            </v-input>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            startingValue: null,
            isBreakApart: null,
        },

        data() {
            return {
                selectedValue: (this.startingValue) ? this.startingValue : '10',
            };
        },
        created() {
            this.update();
        },
        methods: {
            update() {
                if (this.isBreakApart == true) {
                    this.selectedValue = '';
                }
                this.$emit('input', this.selectedValue);
            },
            validate(){
                this.selectedValue = isNaN(parseFloat(this.selectedValue)) ? '' : parseFloat(this.selectedValue);
            },
            onBlur(){
                this.validate();
                this.update();
            }
        },
    };

</script>

<style lang="scss">
    @import '../../style/common/CurvesIntegerInputBox.scss';
</style>
